export const MENU_HELP_HINT_INFO = "Once you have clicked the “Which Hand Wins”-button, the best hand will be highlighted and an explanation visually and in text will appear. If two or more players have the same five-card hand in terms of strength, it’s a split pot and more players will be highlighted.";
export const MENU_HELP_HINT_INFO_POC = false;
export const MENU_HELP_HINT_LIST = [
  "Players 1 and 2 are included in the hand by default.",
  "Use the second dropdown to add more players to the hand.",
  "You can also choose between Texas Hold’em and Omaha in the first dropdown.",
  "On desktop select each player’s hole cards, and afterwards the community cards, by clicking on the card icons on the left.",
  "On mobile select each player’s hole cards, and afterwards community cards, by using the “Click to choose your cards”-button.",
  "Click on any cards to change them.",
  "When having chosen all cards in the hands and on the table, click the “Which Hand Wins?”-button to see the result.",
  "Reset the calculator at any time by clicking the “Reset”-button.",
  ];
export const MENU_HELP_HINT_LIST_POC = [
  "Players 1 and 2 are included in the hand by default.",
  "Use the second dropdown to add more players to the hand (up to 7 for Texas Hold’em and Omaha and up to 5 in the Stud games).",
  "You can also choose between our different games, Texas Hold’em, Texas Hold’em Hi/Lo, Omaha, 7-Card Stud, 7-Card Stud Hi/Lo (with or without qualifier) and Razz.",
  "On desktop select each player’s hole cards, and afterwards community cards (no community cards in the stud games), by clicking on the card icons on the left.",
  "On mobile select each player’s hole cards, and afterwards community cards (no community cards in the stud games), by using the “Click to choose your cards”-button.",
  "Click on any cards to change them.",
  "In Hold’em and Omaha you can get the chances for each player to win by clicking the “Calculate Odds”-button either before the flop, after the flop or after the turn.",
  "In the Stud games (including Razz) you can the chances for each player to win by clicking the “Calculate Odds”-button when all players have a minimum of 3 cards and the same amount exactly. You can therefore get the odds either after 3rd, 4th, 5th or 6th street.",
  "Once you have clicked the “Calculate Odds”-button, the odds for each player to win will be shown. You can moderate the hand afterwards and get the odds again.",
  "Reset the calculator at any time by clicking the “Reset”-button.",
];
export const MENU_HELP_HINT_TITLE = "How to use our Which Hand Wins Calculator";
export const MENU_HELP_HINT_TITLE_POC = "How to use the Poker Odds Calculator";
export const MENU_CURRENT_FIELD_PLAYER = "Player";
export const MENU_CURRENT_FIELD_TABLE = "Choose 0, 3 or 4 community cards";
export const MENU_CURRENT_FIELD_TABLE_WHW = "Choose 5 table cards";
export const MENU_LOGO_TEXT = "WINNING HANDS TOOL";
export const MENU_LOGO_TEXT_POC = "POKER ODDS CALCULATOR";
export const MENU_TITLE = "Choose the game";
export const MENU_SUBTITLE = "and number of players";
export const MENU_MOBILE_CHOOSE_BUTTON = "Click to choose your cards";
export const MENU_CHOOSE_TITLE = "Choose your cards";
export const MENU_CHOOSE_LEFT_CARD = "card";
export const MENU_CHOOSE_LEFT_CARDS = "cards";
export const MENU_RESET_BUTTON = "Reset";
export const MENU_GET_RESULTS_BUTTON = "Which Hand Wins?";
export const MENU_GET_RESULTS_BUTTON_POC = "Calculate Odds";
export const MENU_ERROR_HINT_TITLE = "Error";
export const MENU_ERROR_HINT_INFO = "Please select all cards";
export const MENU_CARDS_LEFT_MORE = " more " ;
export const MENU_CARDS_LEFT_PICK = " to pick ";
export const MENU_CARDS_PLAYER_LEFT_NOCOMMUNITY = "Choose minimum 3 cards, and up to 6";

export const ERROR_NOCOMMUNITY_POC_INFO = "Please select minimum 3 cards per player";
export const ERROR_NOCOMMUNITY_EQUALITY_POC_INFO = "Please select the same amount of cards per player";
export const ERROR_POC_INFO = "Please select all hole cards";
export const ERROR_FLOP_POC_INFO = "Please select a full flop";

export const BOARD_DEALER = "Dealer";
export const BOARD_GET_RESULTS_BUTTON = "Which Hand Wins?";
export const BOARD_GET_RESULTS_BUTTON_POC = "Calculate Odds";
export const BOARD_RESET_BUTTON = "Reset";
export const BOARD_RESET_BUTTON_POC = "Reset cards";

export const PLAYER_WIN_TITLE = "Win:";
export const PLAYER_WINHI_TITLE = "WinHi:";
export const PLAYER_TIE_TITLE = "Tie:";
export const PLAYER_WINLO_TITLE = "WinLo:";

export const RESULT_NOTIFICATION_INFO = "Winning hand";